var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(-1428.144 -1682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M1444.109,1686.069H1437.5a3.308,3.308,0,0,0-3.027,1.983h-.938a.661.661,0,0,0,0,1.322h.66v1.322h-.66a.66.66,0,1,0,0,1.321h.66v1.322h-.66a.661.661,0,0,0,0,1.322h.66v1.322h-.66a.66.66,0,1,0,0,1.321h.66v1.322h-.66a.661.661,0,0,0,0,1.322h.938a3.315,3.315,0,0,0,3.027,1.983h6.609a3.306,3.306,0,0,0,3.3-3.305v-9.252A3.306,3.306,0,0,0,1444.109,1686.069Zm-8.592,12.557v-9.252a1.988,1.988,0,0,1,1.983-1.983v13.218A1.988,1.988,0,0,1,1435.517,1698.626Zm10.575,0a1.989,1.989,0,0,1-1.983,1.983h-5.287v-13.218h5.287a1.989,1.989,0,0,1,1.983,1.983Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 24,
    height: 24,
    transform: "translate(1428.144 1682)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotebook);
export default __webpack_public_path__ + "static/media/icon-notebook.253dc9f97a81b69e73c841535a384f42.svg";
export { ForwardRef as ReactComponent };